import { render, staticRenderFns } from "./SurveyDetail.vue?vue&type=template&id=6dc13700"
import script from "./SurveyDetail.vue?vue&type=script&lang=js"
export * from "./SurveyDetail.vue?vue&type=script&lang=js"
import style0 from "./SurveyDetail.vue?vue&type=style&index=0&id=6dc13700&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc13700')) {
      api.createRecord('6dc13700', component.options)
    } else {
      api.reload('6dc13700', component.options)
    }
    module.hot.accept("./SurveyDetail.vue?vue&type=template&id=6dc13700", function () {
      api.rerender('6dc13700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/SurveyDetail.vue"
export default component.exports